import { lazyLoad } from '@react-page/editor';
import createPlugin from './createPlugin';
import SimpleTextHtmlRenderer from './Renderer/SimpleTextHtmlRenderer';
const SimpleTextControls = lazyLoad(() => import('./Controls/SimpleTextControls'));
const buttonPlugin = (settings) => createPlugin(Object.assign({ Renderer: SimpleTextHtmlRenderer, Controls: SimpleTextControls }, settings));
const button = buttonPlugin();
export default button;
export { buttonPlugin };
//# sourceMappingURL=index.js.map